/* ════════════════════════════════════════════════════════════════
   Iberluffa — Site-wide script
   Inyecta los componentes globales (announcement bar, header, search
   overlay, mobile drawer + submenu, cart drawer, user panel, toast,
   footer) en cualquier página que cargue este archivo, y conecta toda
   la lógica compartida (carrito, búsqueda, drawer móvil, login, etc.).
   El script debe cargarse al FINAL del <body>, antes de los scripts
   específicos de cada página, para que los onclick="..." del HTML
   estático puedan resolver las funciones globales (openCart, addToCart,
   toggleMob, openUserPanel, etc.).
   ════════════════════════════════════════════════════════════════ */

const __SITE_HEADER_MARKUP = "<div class=\"toast\" id=\"toast\"></div>\n\n<!-- ANNOUNCEMENT MARQUEE -->\n<div class=\"ann\" id=\"annBar\">\n  <div class=\"ann-track\">\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">ENVÍO GRATIS A PARTIR DE 60€ EN PENÍNSULA Y 80€ EN EU <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">TRABAJA CON NOSOTROS COMO MAYORISTA <span class=\"ann-sep\">✦</span></span>\n    <span class=\"ann-item\">CREA TU PACK PERSONALIZADO <span class=\"ann-sep\">✦</span></span>\n  </div>\n</div>\n\n<!-- HEADER -->\n<header id=\"hdr\">\n  <div class=\"h-left\">\n    <div class=\"hamburger\" id=\"hbg\" onclick=\"toggleMob()\"><span></span><span></span><span></span></div>\n    <nav class=\"main-nav\">\n      <a href=\"tienda.html\">Tienda<span class=\"tip\">Descubre nuestros bundles personalizados</span></a>\n      <a href=\"blog.html\">Blog<span class=\"tip\">Descubre las últimas noticias</span></a>\n      <div class=\"has-drop\">\n        <a href=\"contacto.html\">Contacto</a>\n        <div class=\"drop\"><div class=\"drop-inner\">\n          <a href=\"contacto.html?form=mayorista\">Mayorista</a><a href=\"contacto.html?form=particular\">Particular</a>\n        </div></div>\n      </div>\n    </nav>\n  </div>\n\n  <a class=\"h-center\" href=\"index.html\" aria-label=\"Ir a la home\">\n    <img class=\"logo-img\" src=\"assets/images/logo/logo-oscurox2.png\" alt=\"Iberluffa\">\n  </a>\n\n  <div class=\"h-right\">\n    <div class=\"ico\" onclick=\"openSrch()\">\n      <svg viewBox=\"0 0 24 24\"><circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"m16.5 16.5 4 4\"/></svg>\n      <span class=\"tip\">Abrir buscador</span>\n    </div>\n    <div class=\"ico user-ico\" onclick=\"toggleUserPanel(event)\">\n      <svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 20c0-4 3.6-7 8-7s8 3 8 7\"/></svg>\n      <span class=\"tip\">Abrir panel de usuario</span>\n    </div>\n    <div class=\"cart-ico-wrap\" onclick=\"openCart()\" id=\"cartWrap\">\n      <div class=\"cart-ico\">\n        <svg viewBox=\"0 0 24 24\"><path d=\"M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z\"/><line x1=\"3\" y1=\"6\" x2=\"21\" y2=\"6\"/><path d=\"M16 10a4 4 0 0 1-8 0\"/></svg>\n      </div>\n      <div class=\"cart-badge\" id=\"cartBadge\">0</div>\n      <span class=\"tip\">Carrito</span>\n    </div>\n  </div>\n</header>\n\n<!-- SEARCH OVERLAY -->\n<div class=\"srch-overlay\" id=\"srchOv\">\n  <div class=\"srch-icon\"><svg viewBox=\"0 0 24 24\"><circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"m16.5 16.5 4 4\"/></svg></div>\n  <input type=\"text\" id=\"srchInput\" placeholder=\"Buscar productos naturales…\" autocomplete=\"off\">\n  <div class=\"srch-close\" onclick=\"closeSrch()\"><svg viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg></div>\n</div>\n\n<!-- MOBILE DRAWER -->\n<div class=\"mob-drawer\" id=\"mobDrw\">\n  <div class=\"mob-nav-wrap\">\n    <nav class=\"mob-nav\">\n      <a href=\"tienda.html\" onclick=\"closeMob()\">Tienda <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n      <a href=\"blog.html\" onclick=\"closeMob()\">Blog <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n      <a href=\"#\" onclick=\"openMobSub(event)\">Contacto <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n      <a href=\"sobre-nosotros.html\" onclick=\"closeMob()\">Sobre nosotros <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n    </nav>\n    <div class=\"mob-sub\" id=\"mobSub\">\n      <a class=\"mob-sub-back\" onclick=\"closeMobSub(event)\">\n        <svg viewBox=\"0 0 24 24\"><path d=\"M19 12H5M12 5l-7 7 7 7\"/></svg>Volver\n      </a>\n      <a href=\"contacto.html?form=mayorista\" onclick=\"closeMob()\">Mayorista <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n      <a href=\"contacto.html?form=particular\" onclick=\"closeMob()\">Particular <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n    </div>\n  </div>\n  <div class=\"mob-util\">\n    <div class=\"mob-util-lbl\">Mi cuenta</div>\n    <div class=\"mob-util-links\">\n      <a href=\"#\" onclick=\"closeMobOpenSrch()\">\n        <svg viewBox=\"0 0 24 24\"><circle cx=\"11\" cy=\"11\" r=\"7\"/><path d=\"m16.5 16.5 4 4\"/></svg>Buscar\n      </a>\n      <a href=\"#\" onclick=\"closeMobOpenUser(event)\">\n        <svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 20c0-4 3.6-7 8-7s8 3 8 7\"/></svg>Panel de usuario\n      </a>\n    </div>\n  </div>\n  <div class=\"mob-lang\">\n    <p class=\"mob-lang-lbl\">Idioma / Language</p>\n    <div class=\"flags\">\n      <div class=\"flag on\" onclick=\"setLang(this)\"><em>🇪🇸</em> ES</div>\n      <div class=\"flag\" onclick=\"setLang(this)\"><em>🇬🇧</em> EN</div>\n      <div class=\"flag\" onclick=\"setLang(this)\"><em>🇵🇹</em> PT</div>\n      <div class=\"flag\" onclick=\"setLang(this)\"><em>🇫🇷</em> FR</div>\n      <div class=\"flag\" onclick=\"setLang(this)\"><em>🇩🇪</em> DE</div>\n    </div>\n  </div>\n</div>\n\n<!-- CART -->\n<div class=\"cart-overlay\" id=\"cartBg\" onclick=\"closeCart()\"></div>\n<div class=\"cart-drawer\" id=\"cartDrawer\">\n  <div class=\"cart-head\">\n    <h3>Tu cesta</h3>\n    <div class=\"cart-head-close\" onclick=\"closeCart()\"><svg viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg></div>\n  </div>\n\n  <!-- Ship bar (se rellena por JS si hay items) -->\n  <div id=\"shipBarSlot\"></div>\n\n  <div class=\"cart-items\" id=\"cartItems\"></div>\n  <div class=\"cart-footer\" id=\"cartFooter\">\n    <div class=\"cart-total-row\">\n      <span class=\"cart-total-lbl\">Total estimado</span>\n      <span class=\"cart-total-price\" id=\"cartTotal\">0,00€</span>\n    </div>\n    <p class=\"cart-note\">Impuestos incluidos. Gastos de envío calculados en el pago.</p>\n    <button class=\"btn-cart-full\" onclick=\"closeCart()\">Ver carrito completo</button>\n    <button class=\"btn-cart-pay\">Ir a pagar →</button>\n  </div>\n</div>\n\n<!-- USER PANEL (login / mi cuenta) — con pestañas Particular / Mayorista -->\n<div class=\"user-panel-bg\" id=\"userPanelBg\" onclick=\"closeUserPanel()\"></div>\n<div class=\"user-panel user-panel-tabs\" id=\"userPanel\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"upTitle\">\n  <button class=\"up-close\" type=\"button\" onclick=\"closeUserPanel()\" aria-label=\"Cerrar\">\n    <svg viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg>\n  </button>\n  <div class=\"up-head\">\n    <img class=\"up-logo\" src=\"assets/images/logo/logo-oscurox2.png\" alt=\"Iberluffa\">\n  </div>\n\n  <div class=\"up-tabs tab-particular\" id=\"authTabs\" role=\"tablist\">\n    <div class=\"up-tabs-ind\"></div>\n    <button type=\"button\" class=\"up-tab on\" data-tab=\"particular\" role=\"tab\" aria-selected=\"true\" onclick=\"switchAuthTab('particular')\">\n      <svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"8\" r=\"4\"/><path d=\"M4 20c0-4 3.6-7 8-7s8 3 8 7\"/></svg>\n      Particular\n    </button>\n    <button type=\"button\" class=\"up-tab\" data-tab=\"mayorista\" role=\"tab\" aria-selected=\"false\" onclick=\"switchAuthTab('mayorista')\">\n      <svg viewBox=\"0 0 24 24\"><rect x=\"3\" y=\"7\" width=\"18\" height=\"13\" rx=\"2\"/><path d=\"M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2\"/></svg>\n      Mayorista\n    </button>\n  </div>\n\n  <div class=\"up-pane on\" data-pane=\"particular\">\n    <h3 class=\"up-title\" id=\"upTitle\">Iniciar sesión</h3>\n    <p class=\"up-sub\">Inicia sesión o crea una cuenta</p>\n    <form class=\"up-form\" onsubmit=\"event.preventDefault();submitParticular();\">\n      <button type=\"button\" class=\"up-shop\" aria-label=\"Continuar con Shop\">\n        Continuar con <span class=\"up-shop-mark\">Shop</span>\n      </button>\n      <div class=\"up-divider\">o</div>\n      <label class=\"up-field\">\n        <span class=\"up-field-label\">Correo electrónico</span>\n        <input type=\"email\" id=\"pEmail\" placeholder=\"tu@email.com\" autocomplete=\"email\">\n      </label>\n      <button type=\"submit\" class=\"up-submit\">Continuar</button>\n      <label class=\"up-check\">\n        <input type=\"checkbox\">\n        <span>Enviarme novedades y ofertas por correo electrónico</span>\n      </label>\n    </form>\n    <p class=\"up-foot\">Si continúas, aceptas nuestros <a href=\"javascript:void(0)\" onclick=\"openLegalPopup('terminos','Términos y condiciones',event)\">Términos del servicio</a> y la <a href=\"javascript:void(0)\" onclick=\"openLegalPopup('privacidad','Política de privacidad',event)\">Política de privacidad</a></p>\n  </div>\n\n  <div class=\"up-pane\" data-pane=\"mayorista\">\n    <h3 class=\"up-title\">Acceso mayorista</h3>\n    <p class=\"up-sub\">Panel B2B exclusivo de Iberluffa</p>\n    <div class=\"up-build\">\n      <div class=\"up-build-ico\" aria-hidden=\"true\">\n        <span class=\"up-build-pulse\"></span>\n        <svg viewBox=\"0 0 24 24\"><path d=\"M3 21h18\"/><path d=\"M5 21V8l7-4 7 4v13\"/><path d=\"M9 21v-6h6v6\"/></svg>\n      </div>\n      <h4 class=\"up-build-h\">Estamos construyendo el nuevo panel</h4>\n      <p class=\"up-build-p\">El panel exclusivo para <strong>mayoristas y minoristas</strong> estará disponible muy pronto. Mientras tanto, escríbenos o llámanos y te atendemos personalmente.</p>\n      <div class=\"up-build-bar\" aria-hidden=\"true\"><span></span></div>\n      <div class=\"up-build-contact\">\n        <a class=\"up-build-link\" href=\"mailto:info@iberluffa.com\">\n          <svg viewBox=\"0 0 24 24\"><rect x=\"3\" y=\"5\" width=\"18\" height=\"14\" rx=\"2\"/><path d=\"m3 7 9 6 9-6\"/></svg>\n          info@iberluffa.com\n        </a>\n        <a class=\"up-build-link\" href=\"tel:+34986530480\">\n          <svg viewBox=\"0 0 24 24\"><path d=\"M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8 9.6a16 16 0 0 0 6 6l1.2-1.1a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6A2 2 0 0 1 22 16.9z\"/></svg>\n          +34 986 530 480\n        </a>\n      </div>\n    </div>\n    <p class=\"up-foot\">¿Eres distribuidor? <a href=\"javascript:void(0)\" onclick=\"closeUserPanel();window.location.href='contacto.html?form=mayorista'\">Solicita información</a></p>\n  </div>\n</div>\n\n<!-- INFO POPUP (página aún no enlazada) -->\n<div class=\"user-panel-bg\" id=\"infoPopupBg\" onclick=\"closeInfoPopup()\"></div>\n<div class=\"user-panel info-popup\" id=\"infoPopup\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"ipTitle\">\n  <button class=\"up-close\" type=\"button\" onclick=\"closeInfoPopup()\" aria-label=\"Cerrar\">\n    <svg viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg>\n  </button>\n  <div class=\"up-head\">\n    <img class=\"up-logo\" src=\"assets/images/logo/logo-oscurox2.png\" alt=\"Iberluffa\">\n  </div>\n  <h3 class=\"up-title\" id=\"ipTitle\">Próximamente</h3>\n  <p class=\"up-sub\" id=\"ipSub\">Esta página aún no está enlazada</p>\n  <div class=\"ip-body\">\n    <div class=\"ip-icon\" aria-hidden=\"true\">\n      <svg viewBox=\"0 0 24 24\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 8v4\"/><circle cx=\"12\" cy=\"16\" r=\".7\" fill=\"currentColor\" stroke=\"none\"/></svg>\n    </div>\n    <p class=\"ip-text\">Estamos trabajando en esta sección. Muy pronto podrás acceder a <strong id=\"ipPage\">esta página</strong>.</p>\n    <p class=\"ip-text ip-text-soft\">Mientras tanto puedes seguir explorando la tienda o contactarnos para cualquier consulta.</p>\n  </div>\n  <div class=\"ip-actions\">\n    <a class=\"up-submit ip-cta\" href=\"tienda.html\">Ir a la tienda</a>\n    <a class=\"ip-cta-ghost\" href=\"contacto.html\">Contactar</a>\n  </div>\n</div>\n\n<!-- LEGAL / PRIVACY POPUP -->\n<div class=\"lgp-bg\" id=\"lgpBg\" onclick=\"closeLegalPopup()\"></div>\n<div class=\"lgp-modal\" id=\"lgpModal\" role=\"dialog\" aria-modal=\"true\" aria-labelledby=\"lgpTitle\">\n  <div class=\"lgp-head\">\n    <span class=\"lgp-eyebrow\">Información legal</span>\n    <h2 class=\"lgp-title\" id=\"lgpTitle\">Política de privacidad</h2>\n    <button class=\"lgp-close\" type=\"button\" onclick=\"closeLegalPopup()\" aria-label=\"Cerrar\"><svg viewBox=\"0 0 24 24\"><path d=\"M18 6 6 18M6 6l12 12\"/></svg></button>\n  </div>\n  <div class=\"lgp-body\" id=\"lgpBody\"><div class=\"lgp-content\" id=\"lgpContent\"></div></div>\n  <div class=\"lgp-foot\">\n    <p class=\"lgp-foot-txt\">¿Dudas sobre el uso de tus datos? <strong>Escríbenos y te ayudamos.</strong></p>\n    <a class=\"lgp-foot-cta\" href=\"legal.html#privacidad\">Página legal completa <svg viewBox=\"0 0 24 24\"><path d=\"M5 12h14M12 5l7 7-7 7\"/></svg></a>\n  </div>\n</div>";
const __SITE_FOOTER_MARKUP = "<!-- FOOTER -->\n<footer>\n  <div class=\"foot-links\">\n    <a href=\"sobre-nosotros.html\">Sobre nosotros</a>\n    <a href=\"contacto.html\">Contacto</a>\n    <a href=\"contacto.html?form=mayorista\">Trabaja con nosotros</a>\n    <a href=\"tienda.html?tab=bundle\">Crea tu pack</a>\n    <a href=\"javascript:void(0)\" onclick=\"(window.openFaqPopup ? window.openFaqPopup() : openInfoPopup(\'Preguntas frecuentes\', this))\">Preguntas frecuentes</a>\n    <a href=\"legal.html\">Información legal</a>\n  </div>\n  <div class=\"foot-soc\">\n    <a class=\"soc-btn\" href=\"https://www.instagram.com/iberluffa.es\" target=\"_blank\" rel=\"noopener\" aria-label=\"Instagram\"><svg viewBox=\"0 0 24 24\"><rect x=\"2\" y=\"2\" width=\"20\" height=\"20\" rx=\"5\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/><circle cx=\"17.5\" cy=\"6.5\" r=\"1.5\" fill=\"#274001\" stroke=\"none\"/></svg></a>\n    <a class=\"soc-btn\" href=\"https://www.facebook.com/Esponjaluffa/\" target=\"_blank\" rel=\"noopener\" aria-label=\"Facebook\"><svg viewBox=\"0 0 24 24\"><path d=\"M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z\"/></svg></a>\n  </div>\n</footer>";

(function injectGlobals(){
  // Comprueba si ya hay un header GLOBAL (por id) — si no, lo inyecta.
  if(!document.getElementById('hdr')){
    /* header estático en Liquid (no se inyecta) */
  }
  if(!document.querySelector('body > footer')){
    /* footer estático en Liquid (no se inyecta) */
  }
  // Marca enlaces de página activa (header nav, mobile drawer, footer).
  // Útil para que el usuario sepa siempre en qué página está.
  try {
    // Marca activa por URL de SHOPIFY (no por nombre .html). Conceptos:
    //  - "Tienda"  → cualquier /collections/* o /products/* (la ficha cuenta como tienda)
    //  - "Blog"    → cualquier /blogs/*
    //  - páginas   → /pages/<x> con match exacto (y si el link trae ?form=, exige el mismo form)
    const clean = p => ((p || '/').split('#')[0].replace(/\/+$/, '') || '/');
    const cur = clean(location.pathname);
    const curForm = new URLSearchParams(location.search).get('form') || '';
    const inTienda = /^\/collections(\/|$)/.test(cur) || /^\/products(\/|$)/.test(cur);
    const inBlog   = /^\/blogs(\/|$)/.test(cur);
    function linkActive(linkPath, linkForm){
      linkPath = clean(linkPath);
      if(/^\/collections(\/|$)/.test(linkPath)) return inTienda;
      if(/^\/blogs(\/|$)/.test(linkPath))       return inBlog;
      if(linkPath === cur) return linkForm ? (linkForm === curForm) : true;
      return false;
    }
    ['.main-nav', '.mob-nav', '.foot-links'].forEach(sel => {
      document.querySelectorAll(sel + ' a').forEach(a => {
        const href = (a.getAttribute('href') || '').trim();
        if(!href || href.startsWith('javascript:') || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('http')) return;
        let u; try { u = new URL(href, location.origin); } catch(_){ return; }
        const linkForm = new URLSearchParams(u.search).get('form') || '';
        if(linkActive(u.pathname, linkForm)){
          a.setAttribute('aria-current', 'page');
          a.classList.add('is-active');
        }
      });
    });
  } catch(e){ /* silencioso — no debe romper la web */ }
})();

const $ = id => document.getElementById(id);

/* ──────────────────────────────────────────────
   CONFIGURACIÓN DE NEGOCIO
   ──────────────────────────────────────────────
   FREE_SHIP: el umbral que se aplica en este HTML demo.
   En Shopify lo detectará la app según la dirección del
   cliente (60€ en España/Península, 80€ en EU). El JS
   simplemente lee window.IBERLUFFA_SHIPPING_THRESHOLD si
   existe, así Shopify puede inyectarlo en el liquid.
   ────────────────────────────────────────────── */
/* Envío: umbral de envío gratis y tarifa según la región de destino. El cliente
   elige su región en el carrito (encima de "Ir a pagar"). Datos de la tabla de
   Envíos (legal): Península 60€ · Baleares/Portugal/UE 80€ · Canarias = consultar. */
const SHIP_REGIONS = {
  peninsula: { free: 60,   rate: 4.90 },
  baleares:  { free: 80,   rate: 7.90 },
  canarias:  { free: null, rate: 12.90 },
  portugal:  { free: 80,   rate: 5.90 },
  eu:        { free: 80,   rate: 9.90 },
};
const SHIP_REGION_ORDER = ['peninsula','baleares','canarias','portugal','eu'];
function ibDetectRegion(){
  try{ var s = localStorage.getItem('ib-ship-region'); if(s && SHIP_REGIONS[s]) return s; }catch(e){}
  var c = (window.IB_COUNTRY || '').toUpperCase();
  if(c === 'PT') return 'portugal';
  if(c && c !== 'ES') return 'eu';
  return 'peninsula';
}
let shipRegion = ibDetectRegion();
function freeShipValue(){ var r = SHIP_REGIONS[shipRegion]; return (r && r.free != null) ? r.free : Infinity; }
let FREE_SHIP = freeShipValue();
function setShipRegion(code){
  if(!SHIP_REGIONS[code]) return;
  shipRegion = code;
  FREE_SHIP = freeShipValue();
  try{ localStorage.setItem('ib-ship-region', code); }catch(e){}
  if(typeof renderCart === 'function') renderCart();
}
/* Texto informativo del selector de envío según el total actual. */
function shipInfoText(total){
  var r = SHIP_REGIONS[shipRegion];
  if(!r || r.free == null) return T('ship_consult');
  if(total >= r.free) return T('ship_free_yes');
  return Tr('ship_free_remaining', { amount: fmt(r.free - total) });
}
/* Markup del selector de región de envío (se inserta en el footer del carrito). */
function shipRegionHTML(total){
  var opts = SHIP_REGION_ORDER.map(function(k){
    return '<button type="button" class="ib-dd-opt'+(k===shipRegion?' on':'')+'" role="option" aria-selected="'+(k===shipRegion?'true':'false')+'" data-value="'+k+'" onclick="ibDdPick(this)">'+T('region_'+k)+'</button>';
  }).join('');
  var rate = SHIP_REGIONS[shipRegion];
  var rateTxt = (rate && rate.free != null && total >= rate.free)
    ? T('ship_free_short')
    : (rate ? Tr('ship_rate', { amount: fmt(rate.rate) }) : '');
  return '<div class="ship-region">'
    + '<div class="ship-region-head">'
    + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M16 3h-3v8h-3l4.5 5 4.5-5h-3z"/><path d="M3 17v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2"/></svg>'
    + '<span class="ship-region-lbl">'+T('ship_to')+'</span>'
    + '<div class="ib-dd ib-dd-up ship-region-dd" data-onpick="setShipRegion"><button type="button" class="ib-dd-btn" onclick="ibDdToggle(this)" aria-haspopup="listbox" aria-expanded="false" aria-label="'+T('ship_to')+'"><span class="ib-dd-val">'+T('region_'+shipRegion)+'</span><svg class="ib-dd-caret" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></svg></button><div class="ib-dd-menu" role="listbox">'+opts+'</div></div>'
    + '</div>'
    + '<p class="ship-region-info">'+shipInfoText(total)+(rateTxt?(' <span class="ship-region-rate">· '+rateTxt+'</span>'):'')+'</p>'
    + '</div>';
}

/* ── DROPDOWN custom (estilo de marca, reemplaza los <select> nativos) ──
   Markup: .ib-dd > .ib-dd-btn(.ib-dd-val) + .ib-dd-menu > .ib-dd-opt[data-value].
   El wrapper puede llevar data-onpick="nombreFuncionGlobal" (recibe el value) y/o
   un <input type="hidden"> que se actualiza para compatibilidad con código existente. */
function ibDdToggle(btn){
  var dd = btn.closest('.ib-dd'); if(!dd) return;
  var willOpen = !dd.classList.contains('open');
  document.querySelectorAll('.ib-dd.open').forEach(function(o){ o.classList.remove('open'); var b=o.querySelector('.ib-dd-btn'); if(b) b.setAttribute('aria-expanded','false'); });
  if(willOpen){ dd.classList.add('open'); btn.setAttribute('aria-expanded','true'); }
}
function ibDdPick(opt){
  var dd = opt.closest('.ib-dd'); if(!dd) return;
  dd.querySelectorAll('.ib-dd-opt').forEach(function(o){ o.classList.remove('on'); o.setAttribute('aria-selected','false'); });
  opt.classList.add('on'); opt.setAttribute('aria-selected','true');
  var val = opt.getAttribute('data-value');
  var valEl = dd.querySelector('.ib-dd-val'); if(valEl) valEl.textContent = opt.textContent;
  dd.classList.remove('open');
  var btn = dd.querySelector('.ib-dd-btn'); if(btn) btn.setAttribute('aria-expanded','false');
  var hidden = dd.querySelector('input[type=hidden]'); if(hidden) hidden.value = val;
  var cb = dd.getAttribute('data-onpick');
  if(cb && typeof window[cb] === 'function'){ window[cb](val); }
}
/* Reposiciona el label/estado de un dropdown según el value (para resets externos). */
function ibDdSetValue(dd, val){
  if(typeof dd === 'string') dd = document.querySelector(dd);
  if(!dd) return;
  var opt = dd.querySelector('.ib-dd-opt[data-value="'+val+'"]'); if(!opt) return;
  dd.querySelectorAll('.ib-dd-opt').forEach(function(o){ o.classList.remove('on'); });
  opt.classList.add('on');
  var valEl = dd.querySelector('.ib-dd-val'); if(valEl) valEl.textContent = opt.textContent;
  var hidden = dd.querySelector('input[type=hidden]'); if(hidden) hidden.value = val;
}
document.addEventListener('click', function(e){
  if(!e.target.closest('.ib-dd')){
    document.querySelectorAll('.ib-dd.open').forEach(function(o){ o.classList.remove('open'); var b=o.querySelector('.ib-dd-btn'); if(b) b.setAttribute('aria-expanded','false'); });
  }
});

/* Tabla de descuentos por cantidad (por línea de producto):
   1 ud  → 0%   2 uds → 10%   3 uds → 15%   4 uds → 18%   5+ uds → 20% */
function getDiscount(qty){
  if(qty>=5) return 0.20;
  if(qty===4) return 0.18;
  if(qty===3) return 0.15;
  if(qty===2) return 0.10;
  return 0;
}
function nextTier(qty){
  if(qty>=5) return null;
  const nq=qty+1; return {qty:nq, pct:getDiscount(nq)};
}

/* ════════════════════════════════════════════════════════════════
   Descuentos por cantidad POR PRODUCTO (de "Precios para particulares web").
   Cada tier es [cantidad_minima, porcentaje]. Producto sin tiers => sin
   descuento. El id de variante (p.ej. sopura--large) usa el del producto base.
   ════════════════════════════════════════════════════════════════ */
const PRODUCT_DISCOUNTS = {
  peelux:   [[2,.05],[3,.06],[4,.07],[5,.08],[6,.09],[7,.10],[8,.12],[9,.13],[10,.15],[20,.20]],
  lufina:   [[2,.05],[3,.10],[4,.12],[5,.15]],
  laluf:    [[2,.05],[3,.10],[4,.12],[5,.15]],
  lufio:    [[2,.05],[3,.10],[4,.12],[5,.15]],
  sopura:   [[2,.05],[3,.10],[4,.12],[5,.15]],
  lufoo:    [[2,.05],[3,.08],[4,.10],[5,.12],[6,.15]],
  soaply:   [[2,.05],[3,.08],[4,.10],[5,.12],[6,.15]],
  lufira:   [[2,.05],[3,.08],[4,.10],[5,.12],[6,.15]],
  peelvita: [[2,.10],[3,.15],[4,.18],[5,.20]],
  thegurk:  [[2,.10],[3,.15],[4,.18],[5,.20]],
};
function discountTiers(id){
  return PRODUCT_DISCOUNTS[id ? String(id).split('--')[0] : ''] || null;
}
function getDiscountFor(id, qty){
  const tiers = discountTiers(id);
  if(!tiers) return 0;
  let pct = 0;
  for(let k=0;k<tiers.length;k++){ if(qty >= tiers[k][0]) pct = tiers[k][1]; }
  return pct;
}
/* Los descuentos por cantidad NO se aplican a bundles personalizados
   ni a los productos llamados "pack" (los packs ya tienen un precio
   compuesto y los bundles tienen su propia composición). */
function isDiscountable(item){
  if(!item) return false;
  if(item.kind === 'bundle') return false;
  // Descuenta cualquier producto con tramos definidos (por id base, incl. variantes
  // como peelux--granel / peelux--pack3). Los sets/bundles no tienen tramos → no se descuentan.
  return !!discountTiers(item.id);
}
function fmt(n){return n.toFixed(2).replace('.',',')+'€'}
function totalsFor(state){
  let subtotal=0, discount=0;
  state.forEach(i=>{
    const base=i.price*i.qty;
    subtotal+=base;
    if(isDiscountable(i)) discount+=base*getDiscountFor(i.id, i.qty);
  });
  return {subtotal, discount, total:subtotal-discount};
}

/* ── HEADER SHADOW ── */
window.addEventListener('scroll',()=>$('hdr').classList.toggle('scrolled',scrollY>10),{passive:true});

/* ── HERO PARALLAX (sólo si hay hero en la página) ──
   También con throttle rAF: en iOS este handler corría en cada pixel de
   scroll y modificaba el transform, lo que sumado al tickCats sobrecargaba
   el hilo principal. */
const heroBg=$('heroBg'), heroEl=document.querySelector('.hero');
if(heroBg && heroEl){
  let __heroRaf = false;
  function tickHero(){
    const y=Math.min(scrollY,heroEl.offsetHeight);
    heroBg.style.transform=`translateY(${y*.3}px)`;
  }
  window.addEventListener('scroll',()=>{
    if(__heroRaf) return;
    __heroRaf = true;
    requestAnimationFrame(()=>{ __heroRaf = false; tickHero(); });
  },{passive:true});
}

/* ── SEARCH ── */
function openSrch(){
  // Cierra menú móvil si estuviera abierto
  if($('mobDrw').classList.contains('open')) closeMob();
  $('srchOv').classList.add('open');
  // Ocultar ann bar (en desktop Y móvil) para que el overlay tenga la altura exacta del header
  $('annBar').classList.add('hidden');
  setTimeout(()=>$('srchInput').focus(),380);
}
function closeSrch(){
  $('srchOv').classList.remove('open');
  // Sólo restaurar la ann bar si tampoco está abierto el menú móvil
  if(!$('mobDrw').classList.contains('open')) $('annBar').classList.remove('hidden');
  // Limpiar resultados y ocultar panel de búsqueda
  const res=$('srchResults'); if(res){res.classList.remove('open');const inner=res.querySelector('.srch-results-inner');if(inner)inner.innerHTML='';}
  const bg=$('srchBg'); if(bg) bg.classList.remove('vis');
  const inp=$('srchInput'); if(inp) inp.value='';
}

/* ── SEARCH AJAX-LIKE: catálogo + sugerencias en vivo ── */
/* i18n: textos de UI desde window.IB_T (snippet iberluffa-i18n.liquid).
   T(k)=texto; Tr(k,{ph:val})=con placeholders {ph}. Si falta IB_T, cae al texto vacío. */
function T(k){ return (window.IB_T && window.IB_T[k] != null) ? window.IB_T[k] : ''; }
function Tr(k, o){ var s = T(k); for(var p in (o||{})) { s = s.split('{'+p+'}').join(o[p]); } return s; }
/* Sub/coletilla de producto traducido (window.IB_PRODUCT_SUBS por id del tema). */
function prodSub(p){ if(!p) return ''; var m = window.IB_PRODUCT_SUBS || {}; var base = String(p.id||'').split('--')[0]; return m[p.id] || m[base] || p.subtitle || p.sub || ''; }
const SITE_PRODUCTS = [
  {id:'lufio',     name:'Lufio',          sub:'Manopla de baño de luffa',         price:16.80, emoji:'🧤'},
  {id:'sopura',    name:'Sopura',         sub:'Estuche para jabones estándar',    price:6.30,  emoji:'🧼'},
  {id:'peelux',    name:'Peelux',         sub:'Discos exfoliantes',               price:1.85,  emoji:'✨'},
  {id:'lufira',    name:'Lufira',         sub:'Esponja de baño',                  price:6.95,  emoji:'🌿'},
  {id:'lufoo',     name:'Lufoo',          sub:'Estropajo multiusos',              price:3.45,  emoji:'🧽'},
  {id:'soaply',    name:'Soaply',         sub:'Soporte jabón',                    price:2.95,  emoji:'🪴'},
  {id:'laluf',     name:'La Luf',         sub:'Esponja de baño cuadrada',         price:6.90,  emoji:'🌾'},
  {id:'lufina',    name:'Lufina',         sub:'La bailarina del baño',            price:7.10,  emoji:'🌿'},
  {id:'peelvita',  name:'Peelvita',       sub:'Esponja para espalda',             price:16.80, emoji:'🌊'},
  {id:'thegurk',   name:'The Gurk',       sub:'Esponja multiusos',                price:16.00, emoji:'🌿'},
  // Los 3 SETS reales (Magic Collection / Working Balance / Signature Series) se añaden
  // desde Shopify en iberluffa-products-data.js (mergeShopifySets, vía window.IB_SETS).
  // Los antiguos set-hombre/set-mujer/pack-bodas eran nombres inventados → eliminados.
];
/* Devuelve info de "pack" para los productos compuestos (sets / packs).
   El badge de búsqueda se pinta sólo si esta función retorna algo. */
function getPackInfo(p){
  if(!p) return null;
  if(p.packSize) return {kind: p.packKind || 'Pack', size: p.packSize};
  if(/^pack[-_ ]/i.test(p.id) || /\bpack\b/i.test(p.name)) return {kind:'Pack', size:4};
  if(/^set[-_ ]/i.test(p.id) || /\bset\b/i.test(p.name))  return {kind:'Set',  size:4};
  return null;
}
// Cada id → ruta de imagen. Productos sin foto propia caen a lufira.png como placeholder.
function prodImg(id){
  const base=String(id||'').split('--')[0];
  // Sets (magic-collection / working-balance / signature-series): no son assets del
  // tema sino MEDIA real de Shopify → su URL está en window.IB_SETS[base].images[0].
  // (Sin esto prodImg caía a una ruta inexistente y la imagen salía rota en carrito,
  // buscador y relacionados.)
  if(window.IB_SETS && window.IB_SETS[base] && window.IB_SETS[base].images && window.IB_SETS[base].images[0]){
    return window.IB_SETS[base].images[0];
  }
  // Mismo caso para los productos dados de alta despues del diseno original
  // (window.IB_EXTRA: Lu Foot, El Camino y cualquier alta futura): su foto es media
  // real de Shopify, no un asset del tema, asi que sin esto salia rota en carrito,
  // buscador y relacionados. Vale igual para variantes (lu-foot--3637 -> lu-foot).
  if(window.IB_EXTRA && window.IB_EXTRA[base] && window.IB_EXTRA[base].images && window.IB_EXTRA[base].images[0]){
    return window.IB_EXTRA[base].images[0];
  }
  const fallbacks=new Set(['set-hombre','set-mujer','pack-bodas']);
  const file = fallbacks.has(base) ? 'lufira' : base;
  // En Shopify las imágenes de los 10 base son assets del tema (product-<id>.png). El mapa
  // window.IB_ASSET (snippet iberluffa-prodmap) da la URL del CDN con su hash.
  if(window.IB_ASSET && window.IB_ASSET[file]) return window.IB_ASSET[file];
  return `assets/images/products/${file}.png?v=3`;
}

function ensureSrchResults(){
  if($('srchResults')) return;
  const ov=$('srchOv'); if(!ov) return;
  // Backdrop dim
  const bg=document.createElement('div');
  bg.className='srch-bg'; bg.id='srchBg';
  bg.addEventListener('click',closeSrch);
  document.body.appendChild(bg);
  // Results panel
  const r=document.createElement('div');
  r.className='srch-results'; r.id='srchResults';
  r.innerHTML='<div class="srch-results-inner" id="srchResultsInner"></div>';
  ov.insertAdjacentElement('afterend', r);
}

function renderSrchResults(query){
  ensureSrchResults();
  const r=$('srchResults'), inner=$('srchResultsInner'), bg=$('srchBg');
  if(!r||!inner) return;
  const q=(query||'').trim().toLowerCase();
  if(!q){
    r.classList.remove('open');
    if(bg) bg.classList.remove('vis');
    inner.innerHTML='';
    return;
  }
  const matches=SITE_PRODUCTS.filter(p=>
    p.name.toLowerCase().includes(q) || p.sub.toLowerCase().includes(q) || p.id.toLowerCase().includes(q)
  );
  r.classList.add('open');
  if(bg) bg.classList.add('vis');
  if(matches.length===0){
    inner.innerHTML=`<div class="srch-empty"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m16.5 16.5 4 4"/></svg><p>${Tr('search_no_results',{q:'<strong>'+escapeHtml(query)+'</strong>'})}</p><p class="srch-empty-sub">${T('search_try_other')}</p></div>`;
    return;
  }
  inner.innerHTML=`
    <p class="srch-count">${matches.length} ${matches.length===1?T('results_one'):T('results_many')}</p>
    <div class="srch-list">${matches.map((p,i)=>{
      const pack=getPackInfo(p);
      const packBadge=pack?`<span class="srch-pack-badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>${pack.kind} · ${pack.size} ${T('products_word')}</span>`:'';
      return `
      <div class="srch-item${pack?' is-pack':''}" data-prod-id="${p.id}" style="animation-delay:${i*30}ms">
        <img src="${prodImg(p.id)}" alt="${p.name}" loading="lazy">
        <div class="srch-item-info">
          <h4>${p.name}</h4>
          <p>${prodSub(p)}</p>
          ${packBadge}
        </div>
        <div class="srch-item-price">${fmt(p.price)}</div>
        <button class="srch-item-add" data-prod="${p.id}" aria-label="${Tr('add_aria',{name:p.name})}" type="button"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>
      </div>`;
    }).join('')}</div>`;
  // Wire add buttons
  inner.querySelectorAll('.srch-item-add').forEach(btn=>{
    btn.addEventListener('click',e=>{
      e.preventDefault();e.stopPropagation();
      const id=btn.dataset.prod;
      const prod=SITE_PRODUCTS.find(x=>x.id===id);
      if(!prod)return;
      // Si el producto tiene variantes (p.ej. peelux: a granel / pack de 3),
      // abrir el popup de opciones en vez de añadir directo (igual que el grid).
      if(prod.sizes && prod.sizes.length>=2){ openQuickOptions(prod, btn); return; }
      addToCart({id:prod.id,name:prod.name,subtitle:prod.sub,price:prod.price,emoji:prod.emoji||''},btn);
    });
  });
}

function escapeHtml(s){return String(s).replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;","'":"&#39;"}[c]));}

// Conectar al input cuando exista
(function wireSearch(){
  const inp=$('srchInput'); if(!inp) return;
  let debounce=null;
  inp.addEventListener('input',e=>{
    clearTimeout(debounce);
    debounce=setTimeout(()=>renderSrchResults(e.target.value),120);
  });
})();
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeSrch();closeCart();closeMob()}});

/* ── MOBILE DRAWER ── */
function toggleMob(){
  const willOpen=!$('mobDrw').classList.contains('open');
  if(willOpen){
    // Si el buscador está abierto lo cerramos para evitar superposición
    if($('srchOv').classList.contains('open')) $('srchOv').classList.remove('open');
  }
  const open=$('mobDrw').classList.toggle('open');
  $('hbg').classList.toggle('open',open);
  document.body.style.overflow=open?'hidden':'';
  if(window.innerWidth<=768) $('annBar').classList.toggle('hidden',open);
}
function closeMob(){
  $('mobDrw').classList.remove('open');
  $('hbg').classList.remove('open');
  document.body.style.overflow='';
  // Sólo quitar 'hidden' si el buscador tampoco está abierto
  if(!$('srchOv').classList.contains('open')) $('annBar').classList.remove('hidden');
  // Reseteo del submenú al cerrar
  const sub=$('mobSub'); if(sub) sub.classList.remove('open');
}
function openMobSub(e){if(e){e.preventDefault();e.stopPropagation();} $('mobSub').classList.add('open');}
function closeMobSub(e){if(e){e.preventDefault();e.stopPropagation();} $('mobSub').classList.remove('open');}
function closeMobOpenSrch(){closeMob();setTimeout(openSrch,350)}
function closeMobOpenUser(e){if(e){e.preventDefault();e.stopPropagation();}closeMob();setTimeout(openUserPanel,300)}

/* ── USER PANEL ── */
function openUserPanel(){
  const p=$('userPanel'),bg=$('userPanelBg');
  if(!p)return;
  p.classList.add('open');bg.classList.add('vis');
  if(window.innerWidth<=768) document.body.style.overflow='hidden';
}
function closeUserPanel(){
  const p=$('userPanel'),bg=$('userPanelBg');
  if(!p)return;
  p.classList.remove('open');bg.classList.remove('vis');
  document.body.style.overflow='';
}
function toggleUserPanel(e){
  if(e){e.preventDefault();e.stopPropagation();}
  const p=$('userPanel');
  if(p && p.classList.contains('open')) closeUserPanel();
  else openUserPanel();
}
/* Cerrar al hacer click fuera del panel (desktop) */
document.addEventListener('click',e=>{
  const p=$('userPanel');
  if(!p || !p.classList.contains('open'))return;
  if(p.contains(e.target))return;
  if(e.target.closest('.user-ico'))return;
  closeUserPanel();
});
/* ESC cierra el panel */
document.addEventListener('keydown',e=>{if(e.key==='Escape')closeUserPanel()});
/* ── SELECTOR DE IDIOMA (PC): abre/cierra el desplegable (la conmutación real la hace
   el form 'localization' nativo de Shopify al enviar cada botón locale_code). ── */
function ibCloseLang(){document.querySelectorAll('.lang-switch.open').forEach(s=>{s.classList.remove('open');const t=s.querySelector('[aria-expanded]');if(t)t.setAttribute('aria-expanded','false')})}
function ibToggleLang(e,el){
  if(e){e.preventDefault();e.stopPropagation()}
  const sw=el.closest('.lang-switch');if(!sw)return;
  const willOpen=!sw.classList.contains('open');
  ibCloseLang();
  if(willOpen){sw.classList.add('open');el.setAttribute('aria-expanded','true')}
}
document.addEventListener('click',e=>{if(!e.target.closest('.lang-switch'))ibCloseLang()});
document.addEventListener('keydown',e=>{if(e.key==='Escape')ibCloseLang()});

/* ── LAZY hover backgrounds: la imagen de hover (data-bg de .prod-hover/.feat-hover)
   se carga SOLO cuando la tarjeta se acerca al viewport → menos peso inicial,
   sobre todo en móvil (en touch el hover solo se usa en el "pulse" al añadir). ── */
(function lazyHoverBg(){
  function load(el){var u=el.getAttribute('data-bg');if(u){el.style.backgroundImage="url('"+u+"')";el.removeAttribute('data-bg');}}
  function init(){
    var els=document.querySelectorAll('[data-bg]');
    if(!('IntersectionObserver' in window)){els.forEach(load);return;}
    var io=new IntersectionObserver(function(ents){ents.forEach(function(e){if(e.isIntersecting){load(e.target);io.unobserve(e.target);}});},{rootMargin:'300px'});
    els.forEach(function(el){io.observe(el);});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();

/* ──────────────────────────────────────────────
   CART
   ────────────────────────────────────────────── */
/* Persistencia del carrito en localStorage (clave por ORIGEN → sobrevive a
   navegación, recarga y cambio de idioma /es /de, que son subrutas del mismo
   dominio). El carrito es una maqueta JS; sin esto se vaciaba en cada carga. */
const IB_CART_KEY='ib-cart';
function loadCart(){
  try{ const a=JSON.parse(localStorage.getItem(IB_CART_KEY)||'[]'); return Array.isArray(a)?a:[]; }
  catch(e){ return []; }
}
function saveCart(){
  try{ localStorage.setItem(IB_CART_KEY, JSON.stringify(cartState)); }catch(e){}
}
let cartState=loadCart();
let lastFreeShip=false;          // para disparar la celebración una sola vez
let pendingAction=null;          // acción pendiente de confirmación

function addToCart(p,el){
  // Cap de stock: si el producto tiene `stock` definido (cargado vía
  // products-data.js), no se permite añadir más del disponible.
  const max = stockFor(p.id);
  const ex=cartState.find(i=>i.id===p.id);
  const current = ex ? ex.qty : 0;
  if(typeof max === 'number' && current + 1 > max){
    showToast(max === 0
      ? T('no_stock')
      : Tr('only_n_left',{n:max}));
    return;
  }
  if(ex)ex.qty++;else cartState.push({...p,qty:1});
  flyToCart(el,p);renderCart();updateBadge();showToast(Tr('added_to_cart',{name:p.name}));
  setTimeout(openCart,420);
}

/* Stock disponible para una line-id del carrito.
   Soporta variantes con sufijo `--xxx` (e.g. `sopura--large`) usando
   la base del producto. Devuelve Infinity si no hay dato (legacy /
   producto sin metadata). */
function stockFor(lineId){
  return Infinity; // stock lo gestionara Shopify; sin limite en el estatico
}

/* ─── BUNDLE EN EL CARRITO ───
   Un bundle se añade como una sola línea con kind:'bundle'.
   - `id` es único por bundle (no se mezcla con otros bundles).
   - `items` es un array de {id, qty} con la composición.
   - `price` es la suma calculada de los items (se recalcula al editar).
   - `qty` SIEMPRE es 1 (cada bundle es único; para "más cantidad" se
     crea otro bundle a través del configurador).
   Los bundles NO reciben el descuento por cantidad (ver isDiscountable). */
function bundlePriceFromItems(items){
  return items.reduce((s,it)=>{
    const p=SITE_PRODUCTS.find(x=>x.id===it.id);
    if(!p) return s;
    const base = p.price*it.qty;
    return s + base*(1 - getDiscountFor(it.id, it.qty));
  },0);
}
function bundleUnitCount(items){ return items.reduce((s,it)=>s+it.qty,0); }

function addBundleToCart(items, triggerEl){
  // Clonar items y filtrar vacíos
  const clean = items.filter(it=>it.qty>0).map(it=>({id:it.id, qty:it.qty}));
  if(clean.length === 0) return;
  const id = 'bundle-' + Date.now().toString(36) + Math.random().toString(36).slice(2,6);
  const n = bundleUnitCount(clean);
  const line = {
    id,
    kind: 'bundle',
    name: T('bundle_name'),
    subtitle: `${n} ${n===1?T('product_one'):T('product_many')}`,
    price: bundlePriceFromItems(clean),
    qty: 1,
    items: clean,
  };
  cartState.push(line);
  // Vuelo de la primera imagen del bundle al carrito
  const first = clean[0];
  if(triggerEl && first){
    flyToCart(triggerEl, {id:first.id});
  }
  renderCart();
  updateBadge();
  showToast(T('bundle_added'));
  setTimeout(openCart, 420);
}

/* Recalcula el precio y subtítulo de un bundle tras editarlo.
   Si queda vacío, elimina la línea del carrito. */
function bundleSync(bundleId){
  const b = cartState.find(i=>i.id===bundleId);
  if(!b || b.kind!=='bundle') return;
  b.items = b.items.filter(it=>it.qty>0);
  if(b.items.length === 0){
    cartState = cartState.filter(i=>i.id!==bundleId);
  } else {
    const n = bundleUnitCount(b.items);
    b.subtitle = `${n} ${n===1?T('product_one'):T('product_many')}`;
    b.price = bundlePriceFromItems(b.items);
  }
  renderCart();
  updateBadge();
}

/* Cambia la cantidad de un producto dentro de un bundle */
function bundleCartEdit(bundleId, prodId, delta){
  const b = cartState.find(i=>i.id===bundleId);
  if(!b || b.kind!=='bundle') return;
  const it = b.items.find(x=>x.id===prodId);
  if(!it){
    if(delta>0) b.items.push({id:prodId, qty:1});
  } else {
    it.qty += delta;
  }
  bundleSync(bundleId);
}
function bundleCartRemoveProd(bundleId, prodId){
  const b = cartState.find(i=>i.id===bundleId);
  if(!b || b.kind!=='bundle') return;
  b.items = b.items.filter(it=>it.id!==prodId);
  bundleSync(bundleId);
}

/* Mostrar/ocultar el "picker" (catálogo) dentro de un bundle */
function bundleCartTogglePicker(bundleId){
  const el = document.querySelector(`.cart-bundle[data-bid="${bundleId}"] .cb-picker`);
  if(!el) return;
  const open = el.classList.toggle('open');
  const btn = document.querySelector(`.cart-bundle[data-bid="${bundleId}"] .cb-add-tile`);
  if(btn) btn.classList.toggle('on', open);
}

/* attemptQtyChange: intenta cambiar una qty pero comprueba antes
   si esa acción nos hace perder el envío gratuito. Si así fuera,
   pinta un banner de confirmación en vez de aplicar el cambio. */
function attemptQty(id,delta){
  const item=cartState.find(i=>i.id===id);
  if(!item)return;
  // Cap de stock al subir
  if(delta > 0){
    const max = stockFor(id);
    if(typeof max === 'number' && item.qty + delta > max){
      showToast(Tr('only_n_left',{n:max}));
      return;
    }
  }
  const oldTotal=totalsFor(cartState).total;
  const wouldRemove=(item.qty+delta)<=0;
  const simulated=wouldRemove
    ? cartState.filter(i=>i.id!==id)
    : cartState.map(i=>i.id===id?{...i,qty:i.qty+delta}:i);
  const newTotal=totalsFor(simulated).total;

  if(oldTotal>=FREE_SHIP && newTotal<FREE_SHIP){
    // Perderá el envío gratis → pedir confirmación
    pendingAction=()=>{
      if(wouldRemove) removeFromCart(id);
      else updateQty(id,delta);
    };
    renderCart();   // muestra el banner
    return;
  }
  // Sin riesgo → aplicar directamente
  if(wouldRemove) removeFromCart(id);
  else updateQty(id,delta);
}
function attemptRemove(id){
  const item=cartState.find(i=>i.id===id);
  if(!item)return;
  const oldTotal=totalsFor(cartState).total;
  const newTotal=totalsFor(cartState.filter(i=>i.id!==id)).total;
  if(oldTotal>=FREE_SHIP && newTotal<FREE_SHIP){
    pendingAction=()=>removeFromCart(id);
    renderCart();
    return;
  }
  removeFromCart(id);
}
function confirmPending(){
  const fn=pendingAction; pendingAction=null;
  if(fn) fn();
  else renderCart();
}
function cancelPending(){pendingAction=null;renderCart()}

function removeFromCart(id){cartState=cartState.filter(i=>i.id!==id);renderCart();updateBadge()}
function updateQty(id,d){
  const item=cartState.find(i=>i.id===id);if(!item)return;
  item.qty+=d;if(item.qty<=0){removeFromCart(id);return}
  renderCart();updateBadge();
}

/* Render del bar de envío gratis */
function renderShipBar(total){
  const slot=$('shipBarSlot');
  if(!cartState.length){slot.innerHTML='';return}
  if(!isFinite(FREE_SHIP)){slot.innerHTML='';return}  // Canarias: envío a consultar, sin barra de progreso
  const done=total>=FREE_SHIP;
  const remaining=Math.max(0,FREE_SHIP-total);
  const pct=Math.min(100,(total/FREE_SHIP)*100);
  slot.innerHTML=`
    <div class="ship-bar ${done?'done':''}" id="shipBar">
      <div class="ship-bar-txt">
        ${done
          ? `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 3 11 8 16 9.5 11 11 9.5 16 8 11 3 9.5 8 8z"/><path d="M18 13l1 3 3 1-3 1-1 3-1-3-3-1 3-1z"/></svg><strong>${T('free_unlocked')}</strong>`
          : `<span>${T('free_remaining_pre')} <strong>${fmt(remaining)}</strong> ${T('free_remaining_post')}</span>`
        }
      </div>
      <div class="ship-track">
        <div class="ship-fill" style="width:${pct}%"></div>
      </div>
      <div class="ship-spark" id="shipSpark"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.5 3 11 8 16 9.5 11 11 9.5 16 8 11 3 9.5 8 8z"/><path d="M18 13l1 3 3 1-3 1-1 3-1-3-3-1 3-1z"/></svg></div>
    </div>`;
}

/* Render de la línea de carrito para un BUNDLE.
   - Foto compuesta (collage 2x2) con badge si hay más de 4 productos.
   - Galería slider editable: cada producto con +/-, eliminar.
   - "Añadir producto" abre un picker con el resto del catálogo. */
function renderBundleCartItem(item){
  const totalUnits = bundleUnitCount(item.items);
  const collageItems = item.items.slice(0, 4);
  const extra = Math.max(0, item.items.length - 4);
  const cells = [];
  for(let i=0; i<4; i++){
    const it = collageItems[i];
    if(it){
      const isLast = (i===3 && extra>0);
      cells.push(`<div class="cb-cell${isLast?' cb-cell-more':''}">
        <img src="${prodImg(it.id)}" alt="">
        ${isLast?`<span class="cb-more-badge">+${extra}</span>`:''}
      </div>`);
    } else {
      cells.push(`<div class="cb-cell cb-cell-empty"></div>`);
    }
  }

  // Gallery: una entrada por producto único en el bundle
  const galTiles = item.items.map(it=>{
    const p = SITE_PRODUCTS.find(x=>x.id===it.id);
    if(!p) return '';
    return `<div class="cb-prod" data-pid="${it.id}">
      <div class="cb-prod-img"><img src="${prodImg(p.id)}" alt="${p.name}"></div>
      <div class="cb-prod-name">${p.name}</div>
      <div class="cb-prod-ctrl">
        <button type="button" onclick="bundleCartEdit('${item.id}','${it.id}',-1)" aria-label="${T('remove_one')}">−</button>
        <span>${it.qty}</span>
        <button type="button" onclick="bundleCartEdit('${item.id}','${it.id}',1)" aria-label="${T('add_one')}">+</button>
      </div>
      <button class="cb-prod-x" type="button" onclick="bundleCartRemoveProd('${item.id}','${it.id}')" aria-label="${T('remove_prod_pack')}">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
      </button>
    </div>`;
  }).join('');

  // Picker: productos del catálogo no presentes (o presentes para subir cantidad)
  const inBundle = new Set(item.items.map(i=>i.id));
  const pickerItems = SITE_PRODUCTS.filter(p=>!inBundle.has(p.id) && !p.noBundle).map(p=>`
    <button class="cb-pick-item" type="button" onclick="bundleCartEdit('${item.id}','${p.id}',1)">
      <img src="${prodImg(p.id)}" alt="">
      <div class="cb-pick-info">
        <span class="cb-pick-name">${p.name}</span>
        <span class="cb-pick-price">${fmt(p.price)}</span>
      </div>
      <span class="cb-pick-add" aria-hidden="true">+</span>
    </button>
  `).join('');

  return `<div class="cart-item cart-bundle" data-bid="${item.id}">
    <div class="cart-bundle-head">
      <div class="cart-bundle-collage" aria-hidden="true">${cells.join('')}</div>
      <div class="cart-bundle-info">
        <div class="cart-bundle-tag">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          ${T('bundle_name')}
        </div>
        <div class="cart-item-name">${totalUnits} ${totalUnits===1?T('product_one'):T('product_many')}</div>
        <div class="cart-item-priceline">
          <span class="cart-item-price">${fmt(item.price)}</span>
        </div>
        <div class="cart-item-row">
          <button class="cb-gal-toggle" type="button" onclick="bundleCartToggleGal('${item.id}')" aria-expanded="false">
            ${T('bundle_view_edit')}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <button class="cart-remove" type="button" onclick="attemptRemove('${item.id}')">${T('remove_pack')}</button>
        </div>
      </div>
    </div>

    <div class="cart-bundle-gallery">
      <div class="cb-gal-track">
        ${galTiles}
        <button class="cb-add-tile" type="button" onclick="bundleCartTogglePicker('${item.id}')" aria-label="${T('add_prod_pack')}">
          <span class="cb-add-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>
          <span class="cb-add-lbl">${T('add')}</span>
        </button>
      </div>
      <div class="cb-picker">
        <div class="cb-pick-head">
          <span>${T('add_to_pack')}</span>
          <button type="button" onclick="bundleCartTogglePicker('${item.id}')" aria-label="${T('close')}"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>
        </div>
        <div class="cb-pick-grid">${pickerItems || `<p class="cb-pick-empty">${T('all_in_pack')}</p>`}</div>
      </div>
    </div>
  </div>`;
}

/* Mostrar / ocultar la galería de un bundle (colapsada por defecto) */
function bundleCartToggleGal(bundleId){
  const card = document.querySelector(`.cart-bundle[data-bid="${bundleId}"]`);
  if(!card) return;
  const open = card.classList.toggle('gal-open');
  const btn = card.querySelector('.cb-gal-toggle');
  if(btn) btn.setAttribute('aria-expanded', String(open));
}

/* Drag-to-scroll para las galerías de bundle en el carrito (delegado).
   En desktop el usuario puede arrastrar con el ratón para ver todos los
   productos del pack. En móvil el touch nativo ya funciona. */
(function wireBundleGalleryDrag(){
  let track=null, startX=0, scrollStart=0, lastX=0, lastT=0, vel=0, raf;
  document.addEventListener('mousedown', e=>{
    const t = e.target.closest('.cb-gal-track');
    if(!t) return;
    // Ignorar clicks sobre botones / tiles (queremos que sigan funcionando)
    if(e.target.closest('button,a,input,.cb-prod-ctrl,.cb-prod-x')) return;
    track = t;
    startX = e.pageX;
    scrollStart = t.scrollLeft;
    lastX = e.pageX; lastT = Date.now(); vel=0;
    t.classList.add('dragging');
    cancelAnimationFrame(raf);
  });
  document.addEventListener('mousemove', e=>{
    if(!track) return;
    const now = Date.now(), dt = now - lastT;
    if(dt>0) vel = (lastX - e.pageX)/dt;
    lastX = e.pageX; lastT = now;
    track.scrollLeft = scrollStart - (e.pageX - startX);
    e.preventDefault();
  });
  function endDrag(){
    if(!track) return;
    const t = track;
    t.classList.remove('dragging');
    // Inercia
    let v = vel * 14;
    function step(){
      if(!t.isConnected || Math.abs(v)<0.4) return;
      t.scrollLeft += v;
      v *= 0.92;
      raf = requestAnimationFrame(step);
    }
    if(Math.abs(v)>0.6) raf = requestAnimationFrame(step);
    track = null;
  }
  document.addEventListener('mouseup', endDrag);
  document.addEventListener('mouseleave', endDrag);
})();

function renderCart(){
  saveCart();   // persiste el carrito en cada render (todas las mutaciones pasan por aquí)
  const c=$('cartItems');if(!c)return;
  const {subtotal,discount,total}=totalsFor(cartState);
  // Free-shipping bar
  renderShipBar(total);

  if(!cartState.length){
    c.innerHTML=`<div class="cart-empty"><svg viewBox="0 0 24 24"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>${T('cart_empty')}</p></div>`;
    $('cartFooter').innerHTML=`
      <div class="cart-total-row">
        <span class="cart-total-lbl">${T('estimated_total')}</span>
        <span class="cart-total-price">0,00€</span>
      </div>
      <p class="cart-note">${T('taxes_note')}</p>
      <button class="btn-cart-pay" onclick="goCheckout()">${T('checkout')}</button>`;
    return;
  }

  const cols={lufio:'#c8b89a',sopura:'#a8b880',peelux:'#c8a880',lufira:'#b0c890',lufoo:'#d0b880',soaply:'#90b8a0',laluf:'#c0a8c8',peelvita:'#d8c090'};

  // Banner de confirmación si hay acción pendiente
  let confirmHTML='';
  if(pendingAction){
    confirmHTML=`
      <div class="cart-confirm">
        <div class="cart-confirm-title">${T('lose_free_title')}</div>
        <p>${Tr('lose_free_body',{amount:fmt(FREE_SHIP)})}</p>
        <div class="cart-confirm-actions">
          <button class="cf-keep" onclick="cancelPending()">${T('keep_free')}</button>
          <button class="cf-remove" onclick="confirmPending()">${T('confirm_remove')}</button>
        </div>
      </div>`;
  }

  const itemsHTML=cartState.map(item=>{
    if(item.kind === 'bundle'){
      return renderBundleCartItem(item);
    }
    const bg=cols[item.id]||'#c8b89a';
    const d=getDiscountFor(item.id, item.qty);
    const base=item.price*item.qty;
    const canDiscount = isDiscountable(item);
    const finalPrice= canDiscount ? base*(1-d) : base;

    const priceLine= (canDiscount && d>0)
      ? `<div class="cart-item-priceline">
           <span class="cart-item-price">${fmt(finalPrice)}</span>
           <span class="cart-item-price-old">${fmt(base)}</span>
         </div>
         <span class="disc-badge">−${Math.round(d*100)}% · ${item.qty} ${T('units_abbr')}</span>`
      : `<div class="cart-item-priceline">
           <span class="cart-item-price">${fmt(base)}</span>
         </div>`;

    const hint = '';

    return `<div class="cart-item">
        <div class="cart-item-img"><img src="${prodImg(item.id)}" alt="${item.name}"></div>
        <div class="cart-item-info">
          <div class="cart-item-name">${item.name}</div>
          <div class="cart-item-sub">${prodSub(item)}</div>
          ${priceLine}
          ${hint}
          <div class="cart-item-row">
            <div class="cart-qty">
              <button onclick="attemptQty('${item.id}',-1)">−</button>
              <span>${item.qty}</span>
              <button onclick="attemptQty('${item.id}',1)">+</button>
            </div>
            <button class="cart-remove" onclick="attemptRemove('${item.id}')">${T('remove')}</button>
          </div>
        </div>
      </div>`;
  }).join('');

  c.innerHTML=confirmHTML+itemsHTML;

  // Footer con desglose
  const saveLine=discount>0
    ? `<div class="cart-fline save"><span class="cart-fline-lbl">${T('qty_discount')}</span><span class="cart-fline-val">−${fmt(discount)}</span></div>`
    : '';
  $('cartFooter').innerHTML=`
    <div class="cart-fline"><span class="cart-fline-lbl">${T('subtotal')}</span><span class="cart-fline-val">${fmt(subtotal)}</span></div>
    ${saveLine}
    <div class="cart-total-row">
      <span class="cart-total-lbl">${T('estimated_total')}</span>
      <span class="cart-total-price">${fmt(total)}</span>
    </div>
    <p class="cart-note">${total>=FREE_SHIP?T('taxes_free'):T('taxes_note')}</p>
    ${shipRegionHTML(total)}
    <button class="btn-cart-pay" onclick="goCheckout()">${T('checkout')}</button>`;

  // Celebración al alcanzar envío gratuito
  const reached=total>=FREE_SHIP;
  if(reached && !lastFreeShip){
    showCelebrate(T('congrats_free'));
    const sp=$('shipSpark'); if(sp){sp.classList.remove('pop');void sp.offsetWidth;sp.classList.add('pop')}
  }
  lastFreeShip=reached;
}

function updateBadge(){
  const badge=$('cartBadge');
  // Cuenta unidades: para bundles sumamos los items del pack
  const n=cartState.reduce((s,i)=>{
    if(i.kind==='bundle') return s + bundleUnitCount(i.items||[]);
    return s + i.qty;
  },0);
  if(n>0){badge.textContent=n>99?'99+':n;badge.classList.add('vis');badge.classList.remove('pop');void badge.offsetWidth;badge.classList.add('pop')}
  else{badge.classList.remove('vis','pop')}
}
function openCart(){$('cartDrawer').classList.add('open');$('cartBg').classList.add('vis');document.body.style.overflow='hidden'}
function closeCart(){$('cartDrawer').classList.remove('open');$('cartBg').classList.remove('vis');document.body.style.overflow='';pendingAction=null}

function flyToCart(triggerEl,product){
  const wrap=$('cartWrap');
  const t=triggerEl.getBoundingClientRect(),c=wrap.getBoundingClientRect();
  const dot=document.createElement('div');dot.className='fly-dot';
  if(product && product.id){
    const img=document.createElement('img');
    img.src=prodImg(product.id);
    img.alt='';
    dot.appendChild(img);
  }
  const size=54;
  dot.style.cssText=`left:${t.left+t.width/2-size/2}px;top:${t.top+t.height/2-size/2}px;width:${size}px;height:${size}px`;
  document.body.appendChild(dot);
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
    dot.style.left=(c.left+c.width/2-9)+'px';dot.style.top=(c.top+c.height/2-9)+'px';
    dot.style.width='18px';dot.style.height='18px';dot.style.opacity='0';dot.style.borderRadius='50%';
  }));
  setTimeout(()=>dot.remove(),750);
}
function handleAdd(e,btn){
  e.stopPropagation();const p=btn.closest('.prod');
  const __pid=p.dataset.id;
  const __pr=(typeof SITE_PRODUCTS!=='undefined')?SITE_PRODUCTS.find(x=>x.id===__pid):null;
  if(__pr && __pr.sizes && __pr.sizes.length>=2){ openQuickOptions(__pr, btn); return; }
  // En móvil: pulso de la capa hover sobre el producto para dar feedback visual
  if(window.innerWidth<=768){
    const hov=p.querySelector('.prod-hover');
    if(hov){
      hov.classList.remove('prod-pulse');
      void hov.offsetWidth;
      hov.classList.add('prod-pulse');
    }
  }
  addToCart({id:p.dataset.id,name:p.dataset.name,subtitle:p.dataset.sub,price:parseFloat(p.dataset.price),emoji:p.dataset.emoji},btn);
}
function showToast(msg){
  const t=$('toast');t.textContent=msg;t.classList.remove('celebrate');t.classList.add('show');
  clearTimeout(t._to);t._to=setTimeout(()=>t.classList.remove('show'),2100);
}
function showCelebrate(msg){
  const t=$('toast');
  t.innerHTML=`<svg viewBox="0 0 24 24" aria-hidden="true" class="toast-spark"><path d="M9.5 3 11 8 16 9.5 11 11 9.5 16 8 11 3 9.5 8 8z"/><path d="M18 13l1 3 3 1-3 1-1 3-1-3-3-1 3-1z"/></svg><span>${msg}</span>`;
  t.classList.add('celebrate','show');
  clearTimeout(t._to);t._to=setTimeout(()=>t.classList.remove('show'),2800);
}

/* ──────────────────────────────────────────────
   BESTSELLERS — drag + inercia + thumb arrastrable
   ────────────────────────────────────────────── */
const prodsEl=$('prodsEl'), bsThumb=$('bsThumb'), bsTrackHit=$('bsTrackHit'), bsTrack=$('bsTrack');

function refreshThumb(){
  if(!prodsEl||!bsThumb)return;
  const total=prodsEl.scrollWidth, visible=prodsEl.clientWidth;
  if(total<=visible){bsThumb.style.width='100%';bsThumb.style.left='0';return}
  const ratio=visible/total;
  const widthPct=Math.max(14,ratio*100);
  bsThumb.style.width=widthPct+'%';
  const maxScroll=total-visible;
  const scrollPct=prodsEl.scrollLeft/maxScroll;
  bsThumb.style.left=(scrollPct*(100-widthPct))+'%';
}

/* Detecta la card "activa" en móvil (la más cercana al centro del slider).
   En desktop limpia la clase para evitar efectos no deseados. */
function updateBestActive(){
  if(!prodsEl)return;
  const prods=prodsEl.querySelectorAll('.prod');
  if(window.innerWidth>768){
    prods.forEach(p=>p.classList.remove('best-active'));
    return;
  }
  const r=prodsEl.getBoundingClientRect();
  const center=r.left+r.width/2;
  let activeIdx=0,minD=Infinity;
  prods.forEach((p,i)=>{
    const pr=p.getBoundingClientRect();
    const c=pr.left+pr.width/2;
    const d=Math.abs(c-center);
    if(d<minD){minD=d;activeIdx=i}
  });
  prods.forEach((p,i)=>p.classList.toggle('best-active',i===activeIdx));
}

if(prodsEl){
  prodsEl.addEventListener('scroll',()=>{refreshThumb();updateBestActive()},{passive:true});
  window.addEventListener('resize',()=>{refreshThumb();updateBestActive()});

  /* ── Drag del slider con INERCIA (para sensación fluida en desktop) ── */
  let dragContent=false, sx=0, sl=0, lastX=0, lastT=0, vel=0, rafInertia;
  function startDrag(x){
    dragContent=true; sx=x; sl=prodsEl.scrollLeft;
    lastX=x; lastT=Date.now(); vel=0;
    prodsEl.classList.add('dragging');
    cancelAnimationFrame(rafInertia);
  }
  function moveDrag(x){
    if(!dragContent)return;
    const now=Date.now(), dt=now-lastT;
    if(dt>0){vel=(lastX-x)/dt} // px/ms
    lastX=x; lastT=now;
    prodsEl.scrollLeft=sl-(x-sx);
  }
  function endDrag(){
    if(!dragContent)return;
    dragContent=false;
    prodsEl.classList.remove('dragging');
    // Inercia
    let v=vel*16; // ~px/frame a 60fps
    function step(){
      if(Math.abs(v)<0.3)return;
      prodsEl.scrollLeft+=v;
      v*=0.93;
      rafInertia=requestAnimationFrame(step);
    }
    if(Math.abs(v)>0.6) rafInertia=requestAnimationFrame(step);
  }
  prodsEl.addEventListener('mousedown',e=>startDrag(e.pageX));
  window.addEventListener('mousemove',e=>moveDrag(e.pageX));
  window.addEventListener('mouseup',endDrag);

  /* ── Drag del THUMB ── */
  let dragThumb=false, thumbStartX=0, scrollStart=0;
  function startThumbDrag(x){
    dragThumb=true; thumbStartX=x; scrollStart=prodsEl.scrollLeft;
    bsTrackHit.classList.add('dragging');
    prodsEl.classList.add('dragging-thumb');
    document.body.style.userSelect='none';
    cancelAnimationFrame(rafInertia);
  }
  function moveThumbDrag(x){
    if(!dragThumb)return;
    const total=prodsEl.scrollWidth, visible=prodsEl.clientWidth;
    const maxScroll=total-visible;
    if(maxScroll<=0)return;
    const trackRect=bsTrack.getBoundingClientRect();
    const tw=bsThumb.offsetWidth;
    const free=trackRect.width-tw;
    if(free<=0)return;
    const dx=x-thumbStartX;
    prodsEl.scrollLeft=Math.max(0,Math.min(maxScroll,scrollStart+(dx/free)*maxScroll));
  }
  function endThumbDrag(){
    if(!dragThumb)return;
    dragThumb=false;
    bsTrackHit.classList.remove('dragging');
    prodsEl.classList.remove('dragging-thumb');
    document.body.style.userSelect='';
  }
  bsThumb.addEventListener('mousedown',e=>{e.stopPropagation();startThumbDrag(e.clientX)});
  window.addEventListener('mousemove',e=>moveThumbDrag(e.clientX));
  window.addEventListener('mouseup',endThumbDrag);
  bsThumb.addEventListener('touchstart',e=>{e.stopPropagation();startThumbDrag(e.touches[0].clientX)},{passive:true});
  window.addEventListener('touchmove',e=>{if(dragThumb)moveThumbDrag(e.touches[0].clientX)},{passive:true});
  window.addEventListener('touchend',endThumbDrag);

  bsTrackHit.addEventListener('click',e=>{
    if(e.target===bsThumb)return;
    const trackRect=bsTrack.getBoundingClientRect();
    const tw=bsThumb.offsetWidth;
    const clickX=e.clientX-trackRect.left;
    const targetLeftPx=Math.max(0,Math.min(trackRect.width-tw,clickX-tw/2));
    const free=trackRect.width-tw;
    if(free<=0)return;
    const pct=targetLeftPx/free;
    const maxScroll=prodsEl.scrollWidth-prodsEl.clientWidth;
    prodsEl.scrollTo({left:pct*maxScroll,behavior:'smooth'});
  });
}

/* ── CATS MOBILE SCROLL-JACK ── */
/*  Fase 1 (0 → 0.82 del scroll): el slider se desplaza horizontalmente,
    todas las categorías están en tamaño AMPLIADO.
    Fase 2 (0.82 → 1): se reduce a tamaño normal (--shrink 0→1) y el
    slider re-equilibra su traslación para que las últimas tarjetas
    sigan ancladas a la derecha del viewport.
    Al hacer scroll inverso (subir desde abajo) el efecto se revierte,
    re-ampliando las tarjetas visibles a la derecha. */
function setupCats(){
  const outer=$('catsOuter');if(!outer)return;
  if(window.innerWidth>768){outer.style.height='';return}
  const slider=$('catsSlider');if(!slider)return;
  /* MEDIR scrollWidth en los dos extremos (shrink=0 y shrink=1) y guardar.
     Como --shrink cambia linealmente el width de cada .cat, el scrollWidth
     también es lineal: lo podemos interpolar en tickCats sin tocar layout. */
  slider.style.setProperty('--shrink',0);
  const maxTxAt0=Math.max(0,slider.scrollWidth-window.innerWidth+20);
  slider.style.setProperty('--shrink',1);
  const maxTxAt1=Math.max(0,slider.scrollWidth-window.innerWidth+20);
  slider.style.setProperty('--shrink',0); // reset visual
  // "Cola" para la fase de reducción
  const tail=Math.round(Math.min(window.innerHeight*0.25, 220));
  outer.style.height=(window.innerHeight+maxTxAt0+tail)+'px';
  outer.dataset.maxtx0=maxTxAt0;
  outer.dataset.maxtx1=maxTxAt1;
  outer.dataset.tail=tail;
}
function tickCats(){
  if(window.innerWidth>768)return;
  const outer=$('catsOuter'),slider=$('catsSlider');
  if(!outer||!slider)return;
  const rect=outer.getBoundingClientRect();
  const total=outer.offsetHeight-window.innerHeight;
  const maxTx0=+outer.dataset.maxtx0||0;
  const maxTx1=+outer.dataset.maxtx1||0;
  const tail=+outer.dataset.tail||0;
  const slidePart=total-tail;
  const scrolled=Math.max(0,Math.min(total,-rect.top));
  const slideP=slidePart>0?Math.min(scrolled/slidePart,1):1;
  const shrinkP=tail>0?Math.max(0,Math.min(1,(scrolled-slidePart)/tail)):0;
  /* INTERPOLACIÓN matemática: NO leemos scrollWidth aquí.
     Antes esto causaba layout thrashing (set --shrink → leer scrollWidth)
     que en iPhone hacía que el slider fuera "a cachitos". */
  const curMaxTx = maxTx0 + (maxTx1 - maxTx0) * shrinkP;
  slider.style.setProperty('--shrink',shrinkP);
  slider.style.transform=`translateX(${-slideP*curMaxTx}px)`;
  const overallP=Math.max(0,Math.min(1,scrolled/total));
  const cb=$('catsBar');if(cb)cb.style.width=(overallP*100)+'%';
  const hint=$('catsHint');if(hint)hint.style.opacity=overallP>0.95?'0':'1';
}
setupCats();

/* Pausar la animación del hint cuando no está cerca del viewport: ahorra
   GPU y libera al compositor en iPhone (la animación corría siempre, incluso
   con la sección a miles de px de distancia). */
(function activateCatsHintWhenNear(){
  const hint = $('catsHint');
  const outer = $('catsOuter');
  if(!hint || !outer || !('IntersectionObserver' in window)){
    if(hint) hint.classList.add('cats-hint-on');
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => hint.classList.toggle('cats-hint-on', e.isIntersecting));
  }, { rootMargin: '120px 0px 200px 0px' });
  io.observe(outer);
})();

/* requestAnimationFrame throttle del scroll handler.
   Sin esto, en iOS/iPhone el scroll dispara muchísimas veces por segundo y
   cada llamada a tickCats fuerza getBoundingClientRect + 3 modificaciones
   de estilo (layout + repaint). Coalescemos a 1 ejecución por frame. */
let __catsScrollRaf = false;
function onCatsScroll(){
  if(__catsScrollRaf) return;
  __catsScrollRaf = true;
  requestAnimationFrame(() => {
    __catsScrollRaf = false;
    tickCats();
  });
}
window.addEventListener('scroll', onCatsScroll, {passive:true});
window.addEventListener('resize',()=>{setupCats();tickCats();refreshThumb();updateBestActive()});

/* ── SELLO 100% NATURAL: scale ligero ligado al scroll dentro de su sección ──
   Se mantiene quieto (sin rotación). Conforme bajas el scroll dentro de la
   sección misión, se va ampliando suavemente. Reversible al subir. */
const misionEl=document.querySelector('.mision'), selloEl=document.querySelector('.sello');
function tickSello(){
  if(!misionEl||!selloEl)return;
  // En móvil (iOS sobre todo) la barra de Safari muestra/oculta al hacer scroll
  // → window.innerHeight cambia a media animación y el scale "crecía/encogía/crecía"
  // (jitter). Escala fija en móvil: el sello queda quieto y legible.
  if(window.innerWidth<=768){ selloEl.style.transform=''; return; }
  const r=misionEl.getBoundingClientRect();
  const vh=window.innerHeight;
  const total=r.height+vh;
  const p=Math.max(0,Math.min(1,(vh-r.top)/total));
  const scale=0.82 + p*0.28; // 0.82 → 1.10
  selloEl.style.transform=`scale(${scale})`;
}
// Mismo throttle con rAF para el handler del sello.
let __selloScrollRaf = false;
function onSelloScroll(){
  if(__selloScrollRaf) return;
  __selloScrollRaf = true;
  requestAnimationFrame(() => {
    __selloScrollRaf = false;
    tickSello();
  });
}
window.addEventListener('scroll', onSelloScroll, {passive:true});
window.addEventListener('resize',tickSello);
tickSello();

/* ── SCROLL REVEAL ── */
const ro=new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('vis');ro.unobserve(e.target)}});
},{threshold:.08});
document.querySelectorAll('.reveal').forEach(el=>ro.observe(el));

/* ── NAVEGACIÓN A LA FICHA DE PRODUCTO ──
   Click en cualquier .prod, .feat-card o .srch-item lleva a producto.html?id=X.
   El botón "+ Añadir a la cesta" (qadd) y otros buttons internos no propagan
   gracias a stopPropagation() en handleAdd / addEventListener. */
document.addEventListener('click', e => {
  // Search result item
  const srchItem = e.target.closest('.srch-item');
  if(srchItem && !e.target.closest('button, a')){
    const id = srchItem.dataset.prodId;
    if(id){
      closeSrch();
      window.location.href = `${window.IB_LROOT||''}/pages/producto?id=${encodeURIComponent(id)}`;
      return;
    }
  }
  // Product card en tienda / featured / related
  const card = e.target.closest('.prod, .feat-card');
  if(!card || !card.dataset.id) return;
  if(e.target.closest('button, a')) return;
  window.location.href = `${window.IB_LROOT||''}/pages/producto?id=${encodeURIComponent(card.dataset.id)}`;
});

/* ── INIT ── */
renderCart();updateBadge();
requestAnimationFrame(()=>requestAnimationFrame(()=>{refreshThumb();updateBestActive()}));

/* ── INFO POPUP (páginas aún no enlazadas) ──
   Acepta opcionalmente el evento o el elemento de origen. En desktop,
   intenta posicionar el popup cerca del elemento que lo dispara (header →
   debajo con flecha arriba; footer → encima con flecha abajo; lateral si
   no entra ni arriba ni abajo). Si algo falla, hace fallback a centrado.
   En móvil siempre como bottom-sheet.
*/
function openInfoPopup(pageName, evtOrEl){
  try {
    const p = document.getElementById('infoPopup'),
          bg = document.getElementById('infoPopupBg');
    if(!p || !bg) return;

    // Cierra otros overlays para no apilar
    try { closeUserPanel(); } catch(_){}
    const sub = document.getElementById('mobSub');
    if(sub) sub.classList.remove('open');

    const titleEl = document.getElementById('ipTitle');
    const pageEl  = document.getElementById('ipPage');
    if(pageName){
      if(titleEl) titleEl.textContent = pageName;
      if(pageEl)  pageEl.textContent  = '“' + pageName + '”';
    } else {
      if(titleEl) titleEl.textContent = 'Próximamente';
      if(pageEl)  pageEl.textContent  = 'esta página';
    }

    // Resolver elemento "origen" del click (si lo pasaron)
    let trigger = null;
    try {
      if(evtOrEl){
        if(evtOrEl.currentTarget && evtOrEl.currentTarget.nodeType === 1) trigger = evtOrEl.currentTarget;
        else if(evtOrEl.nodeType === 1) trigger = evtOrEl;
        else if(evtOrEl.target && typeof evtOrEl.target.closest === 'function')
          trigger = evtOrEl.target.closest('a,button') || evtOrEl.target;
      }
    } catch(_){ trigger = null; }

    // Reset estilos y clases del popup
    p.style.top = p.style.left = p.style.right = p.style.bottom = '';
    p.style.transformOrigin = '';
    try {
      p.style.setProperty('--arrow-left', '');
      p.style.setProperty('--arrow-top', '');
    } catch(_){}
    p.classList.remove('arrow-top','arrow-bottom','arrow-left','arrow-right','centered');

    const isMobile = window.innerWidth <= 768;

    if(isMobile){
      // Móvil: bottom sheet (lo gestiona el CSS responsive)
    } else if(!trigger){
      // Desktop sin trigger: centrado
      p.classList.add('centered');
    } else {
      // Desktop con trigger: posicionar cerca del elemento
      try {
        const r = trigger.getBoundingClientRect();
        // Si el rect está vacío (elemento oculto), caemos a centered
        if(!r || (!r.width && !r.height && !r.left && !r.top)){
          p.classList.add('centered');
        } else {
          const W = window.innerWidth, H = window.innerHeight;
          const pw = 340, ph = 380, gap = 14, margin = 12;
          const cx = r.left + r.width/2;
          const cy = r.top + r.height/2;
          const placeAbove = cy > H * 0.62 && (r.top - ph - gap) > margin;
          const placeBelow = !placeAbove && (r.bottom + ph + gap < H - margin);
          let side = placeAbove ? 'top'
                   : placeBelow ? 'bottom'
                   : (cx > W/2 ? 'left' : 'right');

          if(side === 'bottom'){
            p.classList.add('arrow-top');
            let left = Math.max(margin, Math.min(Math.round(cx - pw/2), W - pw - margin));
            p.style.left = left + 'px';
            p.style.right = 'auto';
            p.style.top  = Math.round(r.bottom + gap) + 'px';
            p.style.transformOrigin = 'top center';
            p.style.setProperty('--arrow-left', Math.max(18, Math.min(pw - 18, cx - left)) + 'px');
          } else if(side === 'top'){
            p.classList.add('arrow-bottom');
            let left = Math.max(margin, Math.min(Math.round(cx - pw/2), W - pw - margin));
            p.style.left = left + 'px';
            p.style.right = 'auto';
            p.style.bottom = Math.round(H - r.top + gap) + 'px';
            p.style.transformOrigin = 'bottom center';
            p.style.setProperty('--arrow-left', Math.max(18, Math.min(pw - 18, cx - left)) + 'px');
          } else if(side === 'right'){
            p.classList.add('arrow-left');
            let top = Math.max(margin, Math.min(Math.round(cy - ph/2), H - ph - margin));
            p.style.left = Math.round(r.right + gap) + 'px';
            p.style.right = 'auto';
            p.style.top = top + 'px';
            p.style.transformOrigin = 'left center';
            p.style.setProperty('--arrow-top', Math.max(18, Math.min(ph - 18, cy - top)) + 'px');
          } else {
            p.classList.add('arrow-right');
            let top = Math.max(margin, Math.min(Math.round(cy - ph/2), H - ph - margin));
            p.style.right = Math.round(W - r.left + gap) + 'px';
            p.style.left = 'auto';
            p.style.top = top + 'px';
            p.style.transformOrigin = 'right center';
            p.style.setProperty('--arrow-top', Math.max(18, Math.min(ph - 18, cy - top)) + 'px');
          }
        }
      } catch(err){
        // Fallback: centrado si algo falla
        p.classList.add('centered');
      }
    }

    p.classList.add('open');
    bg.classList.add('vis');
    if(window.innerWidth <= 768) document.body.style.overflow = 'hidden';

    // Quitar foco del elemento que abrió el popup para evitar el "estado
    // pegado" que en touch hace que el botón parezca duplicado.
    try { if(trigger && typeof trigger.blur === 'function') trigger.blur(); } catch(_){}
  } catch(err){
    // Última red de seguridad: si TODO falla, al menos intenta abrir centrado
    try {
      const p = document.getElementById('infoPopup'),
            bg = document.getElementById('infoPopupBg');
      if(p){ p.classList.add('open','centered'); }
      if(bg){ bg.classList.add('vis'); }
    } catch(_){}
  }
}
function closeInfoPopup(){
  const p = $('infoPopup'), bg = $('infoPopupBg');
  if(!p) return;
  p.classList.remove('open');
  bg.classList.remove('vis');
  document.body.style.overflow = '';
}
/* ESC cierra info popup */
document.addEventListener('keydown', e => { if(e.key === 'Escape') closeInfoPopup(); });

/* ════════════════════════════════════════════════════════════════
   AUTH — login con pestañas Particular / Mayorista
   Añadido para integrar el panel B2B (panel.html).
   ════════════════════════════════════════════════════════════════ */

/* Cambia entre las pestañas Particular y Mayorista del user-panel */
function switchAuthTab(tab){
  const t = document.getElementById('authTabs');
  if(!t) return;
  t.classList.remove('tab-particular','tab-mayorista');
  t.classList.add('tab-' + tab);
  t.querySelectorAll('.up-tab').forEach(b => {
    const on = b.dataset.tab === tab;
    b.classList.toggle('on', on);
    b.setAttribute('aria-selected', on ? 'true' : 'false');
  });
  document.querySelectorAll('.up-pane').forEach(p => {
    p.classList.toggle('on', p.dataset.pane === tab);
  });
}

/* LOGIN — cuentas NUEVAS de Shopify (passwordless / Shop). El flujo de
   autenticación está alojado por Shopify (account.<dominio>) y no se puede
   embeber. Para NO sacar al usuario de la página actual, lo abrimos en un
   POPUP; cuando el login termina, Shopify devuelve el popup a NUESTRO dominio
   (return_url) → lo detectamos, cerramos el popup y refrescamos la página (ya
   logueado). Si el navegador bloquea el popup, caemos a redirección normal.
   ⚠️ /account/* da 500 en el preview de `theme dev`; el login completo solo se
   prueba en la tienda PUBLICADA. */
function ibOpenLogin(){
  var ret = location.pathname + location.search;
  var url = '/account/login?return_url=' + encodeURIComponent(ret);
  var w = 480, h = 720;
  var x = Math.max(0, Math.round(((screen.width  || 1200) - w) / 2));
  var y = Math.max(0, Math.round(((screen.height || 800) - h) / 3));
  var popup = null;
  try { popup = window.open(url, 'iberluffa_login', 'popup=yes,width=' + w + ',height=' + h + ',left=' + x + ',top=' + y); } catch(e){ popup = null; }
  if(!popup){ window.location.href = url; return; }   // popup bloqueado → redirección
  try { popup.focus(); } catch(e){}
  if(typeof closeUserPanel === 'function') closeUserPanel();
  var timer = setInterval(function(){
    try {
      if(popup.closed){ clearInterval(timer); return; }   // cerrado sin loguear
      // Cuando el popup vuelve a NUESTRO origen Y ya no está en la ruta de login
      // (la URL inicial /account/login es mismo-origen un instante antes del 302
      // al dominio de Shopify; la excluimos para no disparar en falso):
      if(popup.location && popup.location.origin === window.location.origin
         && popup.location.pathname.indexOf('/account/login') !== 0){
        clearInterval(timer);
        try { popup.close(); } catch(e){}
        window.location.reload();
      }
    } catch(e){ /* sigue en el dominio de Shopify (cross-origin) → seguir esperando */ }
  }, 700);
}

/* El botón "Continuar con Shop" y el formulario de email del panel abren ambos
   el login en popup (el flujo de Shopify pide el email / ofrece Shop dentro). */
function goLogin(){ ibOpenLogin(); }
function submitParticular(){ ibOpenLogin(); }

/* Ir a pagar. El drawer es una maqueta (cartState) con animaciones/bundles/
   preview de descuentos. Al pulsar "Ir a pagar" SINCRONIZAMOS ese carrito con
   el carrito real de Shopify (Cart AJAX) y redirigimos a /checkout. Los variant
   IDs reales vienen de window.IB_VARIANTS (snippet iberluffa-variants.liquid).
   NOTA: los descuentos por cantidad se aplicarán en checkout vía descuento
   automático de Shopify (fase pendiente); hasta entonces el checkout muestra
   precio sin el descuento que previsualiza el drawer. */
function goCheckout(){
  if(typeof cartState === 'undefined' || !cartState.length){ showToast(T('cart_empty')); return; }
  const V = window.IB_VARIANTS || {};
  function variantFor(id){
    return V[id] || V[String(id).split('--')[0]] || null;
  }
  // Construir líneas {id: variantId, quantity}, expandiendo bundles a sus componentes.
  const lines = [];
  cartState.forEach(function(it){
    if(it.kind === 'bundle'){
      (it.items || []).forEach(function(sub){
        const vid = variantFor(sub.id);
        if(vid) lines.push({ id: vid, quantity: sub.qty * (it.qty || 1) });
      });
    } else {
      const vid = variantFor(it.id);
      if(vid) lines.push({ id: vid, quantity: it.qty });
    }
  });
  if(!lines.length){
    showToast(T('payment_error_prep'));
    return;
  }
  showToast(T('preparing_payment'));
  // Reconstruimos el carrito de Shopify desde cero para que coincida con el drawer.
  fetch('/cart/clear.js', { method:'POST', headers:{'Content-Type':'application/json'} })
    .then(function(){
      return fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ items: lines })
      });
    })
    .then(function(res){
      if(!res.ok) throw new Error('cart/add ' + res.status);
      window.location.href = '/checkout';
    })
    .catch(function(err){
      console.error('[goCheckout]', err);
      showToast(T('payment_error'));
    });
}



/* Si la URL tiene ?login=mayorista, abrir el panel con la pestaña activa */
(function autoOpenMayoristaLogin(){
  function init(){
    const qs = new URLSearchParams(location.search);
    if(qs.get('login') === 'mayorista'){
      setTimeout(()=>{
        if(typeof openUserPanel === 'function'){
          openUserPanel();
          switchAuthTab('mayorista');
        }
      }, 250);
    }
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ════════════════════════════════════════════════════════════════
   LEGAL POPUP — muestra una sección de legal.html en un modal moderno.
   Sincronizado: hace fetch de legal.html y extrae la sección por id,
   así el contenido legal vive en un único sitio.
   ════════════════════════════════════════════════════════════════ */
var __legalDocCache = null;
function openLegalPopup(sectionId, label, evt){
  if(evt){ try{ evt.preventDefault(); evt.stopPropagation(); }catch(_){} }
  var modal = document.getElementById('lgpModal'),
      bg    = document.getElementById('lgpBg'),
      body  = document.getElementById('lgpContent'),
      titleEl = document.getElementById('lgpTitle');
  if(!modal || !bg || !body) return;
  try{ closeUserPanel(); }catch(_){}
  try{ closeInfoPopup(); }catch(_){}
  if(label && titleEl) titleEl.textContent = label;

  function show(){
    bg.classList.add('vis');
    modal.classList.add('open');
    if(window.innerWidth <= 768) document.body.style.overflow = 'hidden';
    var bd = document.getElementById('lgpBody'); if(bd) bd.scrollTop = 0;
  }
  function fill(doc){
    var sec = doc.getElementById(sectionId);
    if(!sec){
      body.innerHTML = '<p>' + (T('legal_error') || 'No se pudo cargar el contenido.') + ' <a href="'+(window.IB_LROOT||'')+'/pages/legal#'+sectionId+'">' + (T('legal_error_link') || 'Abrir la página legal') + '</a>.</p>';
      return;
    }
    var clone = sec.cloneNode(true);
    var rm = clone.querySelectorAll('h2, .legal-section-foot');
    for(var i=0;i<rm.length;i++){ rm[i].parentNode.removeChild(rm[i]); }
    body.innerHTML = clone.innerHTML;
  }

  if(__legalDocCache){ fill(__legalDocCache); show(); return; }

  body.innerHTML = '<p class="lgp-loading">' + (T('loading') || 'Cargando…') + '</p>';
  show();
  fetch((window.IB_LROOT||'') + '/pages/legal').then(function(r){ return r.text(); }).then(function(html){
    __legalDocCache = new DOMParser().parseFromString(html, 'text/html');
    fill(__legalDocCache);
  }).catch(function(){
    body.innerHTML = '<p>' + (T('legal_error') || 'No se pudo cargar el contenido ahora mismo.') + ' <a href="'+(window.IB_LROOT||'')+'/pages/legal#'+sectionId+'">' + (T('legal_error_link') || 'Abrir la página legal') + '</a>.</p>';
  });
}
function closeLegalPopup(){
  var modal = document.getElementById('lgpModal'),
      bg    = document.getElementById('lgpBg');
  if(modal) modal.classList.remove('open');
  if(bg) bg.classList.remove('vis');
  document.body.style.overflow = '';
}
document.addEventListener('keydown', function(e){
  if(e.key === 'Escape'){ closeLegalPopup(); }
});

/* ════════════════════════════════════════════════════════════════
   QUICK OPTIONS — al pulsar "+ Añadir a la cesta" en el grid de un
   producto con variantes (sizes), se elige la opción antes de añadir.
   ════════════════════════════════════════════════════════════════ */
function openQuickOptions(prod, btn){
  let bg = document.getElementById('qoBg');
  if(!bg){
    bg = document.createElement('div'); bg.id='qoBg'; bg.className='qo-bg';
    bg.innerHTML = '<div class="qo-pop" id="qoPop" role="dialog" aria-modal="true"></div>';
    document.body.appendChild(bg);
    bg.addEventListener('click', function(e){ if(e.target===bg) closeQuickOptions(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeQuickOptions(); });
  }
  const pop = document.getElementById('qoPop');

  // Un producto con DOS opciones en Shopify (Lu Foot: Talla y Tipo) llega con las dos juntas
  // en la etiqueta: "36/37 / Barefoot". Doce seguidas no se leen, asi que se elige primero el
  // tipo y luego la talla, igual que en la ficha. Con un solo eje todo sigue como estaba.
  function partes(z){
    const p = String(z.label).split(' / ');
    return p.length === 2 ? { talla: p[0].trim(), tipo: p[1].trim() } : null;
  }
  const dosEjes = prod.sizes.length > 0 && prod.sizes.every(partes);
  let tipoElegido = dosEjes
    ? partes(prod.sizes.find(function(z){ return z.available !== false; }) || prod.sizes[0]).tipo
    : null;

  // Una opcion sin stock en Shopify se muestra pero no se puede elegir: si se
  // pudiera, el /cart/add.js del checkout la rechazaria despues.
  function botonVariante(z, etiqueta){
    const off = z.available === false;
    const sub = z.sub || (off ? T('no_stock') : '');
    return '<button class="qo-opt'+(off?' is-off':'')+'" type="button" data-sid="'+z.id+'"'+(off?' disabled aria-disabled="true"':'')+'><span class="qo-opt-info"><span class="qo-opt-name">'+(etiqueta||z.label)+'</span>'+(sub?'<span class="qo-opt-sub">'+sub+'</span>':'')+'</span><span class="qo-opt-price">'+fmt(z.price)+'</span></button>';
  }

  function pinta(){
    let cuerpo;
    if(dosEjes){
      const tipos = prod.sizes.map(function(z){ return partes(z).tipo; })
        .filter(function(t,i,a){ return a.indexOf(t)===i; });
      const fila = tipos.map(function(t){
        const hay = prod.sizes.some(function(z){ return partes(z).tipo===t && z.available!==false; });
        return '<button class="qo-tipo'+(t===tipoElegido?' on':'')+(hay?'':' is-off')+'" type="button" data-tipo="'+t+'"'+(hay?'':' disabled aria-disabled="true"')+'>'+t+'</button>';
      }).join('');
      const tallas = prod.sizes.filter(function(z){ return partes(z).tipo===tipoElegido; })
        .map(function(z){ return botonVariante(z, partes(z).talla); }).join('');
      cuerpo = '<div class="qo-tipos">'+fila+'</div><div class="qo-opts">'+tallas+'</div>';
    } else {
      cuerpo = '<div class="qo-opts">'+prod.sizes.map(function(z){ return botonVariante(z); }).join('')+'</div>';
    }

    pop.innerHTML = '<button class="qo-close" type="button" aria-label="Cerrar" onclick="closeQuickOptions()"><svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg></button><span class="qo-eyebrow">Elige una opción</span><h3 class="qo-title">'+prod.name+'</h3>'+cuerpo;

    pop.querySelectorAll('.qo-tipo').forEach(function(b){
      b.addEventListener('click', function(){ tipoElegido = b.dataset.tipo; pinta(); });
    });
    pop.querySelectorAll('.qo-opt').forEach(function(b){
      b.addEventListener('click', function(){
        const z = prod.sizes.find(function(x){ return x.id===b.dataset.sid; });
        addToCart({ id: prod.id+'--'+z.id, name: prod.name+' ('+z.label+')', subtitle:(prod.sub||'')+' · '+z.label, price: z.price, emoji: prod.emoji||'' }, btn);
        closeQuickOptions();
      });
    });
  }
  pinta();

  requestAnimationFrame(function(){ requestAnimationFrame(function(){ bg.classList.add('vis'); }); });
}
function closeQuickOptions(){
  const bg=document.getElementById('qoBg'); if(bg) bg.classList.remove('vis');
}
